import type { CheckResult } from "../../lib/types.js";
import styles from "./CheckRow.module.css";

interface CheckRowProps {
  check: CheckResult;
  checkName?: string;
  onRerun?: () => void;
  disabled?: boolean;
  selected?: boolean;
  onSelect?: (selected: boolean) => void;
}

function StatusIcon({ ok, warning }: { ok: boolean | null; warning?: boolean }) {
  if (ok === null) return <span className={styles.iconOff} aria-label="off">○</span>;
  if (warning) return <span className={styles.iconWarn} aria-label="warning">⚠</span>;
  if (ok) return <span className={styles.iconPass} aria-label="pass">✓</span>;
  return <span className={styles.iconFail} aria-label="fail">✗</span>;
}

export function CheckRow({ check, checkName, onRerun, disabled, selected, onSelect }: CheckRowProps) {
  const isOff = check.detail?.includes("disabled") ?? false;
  const isWarning = check.warning === true && !check.ok;
  const displayName = checkName ?? check.checkName ?? check.slug;

  return (
    <div className={`${styles.row} ${!check.ok && !isOff && !isWarning ? styles.rowFail : ""} ${isOff ? styles.rowOff : ""} ${isWarning ? styles.rowWarn : ""}`}>
      {onSelect && (
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={selected ?? false}
          onChange={(e) => onSelect(e.target.checked)}
          disabled={check.ok || isOff}
        />
      )}
      <StatusIcon ok={isOff ? null : check.ok} warning={isWarning} />
      <div className={styles.info}>
        <span className={styles.name}>{displayName}</span>
        <code className={styles.slug}>{check.slug}</code>
      </div>
      {check.value !== undefined && (
        <span className={styles.value}>{check.value}</span>
      )}
      {check.detail && (
        <span className={styles.detail}>{check.detail}</span>
      )}
      <span className={styles.duration}>{check.duration_ms}ms</span>
      {!check.ok && !isOff && !isWarning && onRerun && (
        <button
          className={styles.rerunBtn}
          onClick={onRerun}
          disabled={disabled}
          title="Rerun this check"
        >
          ↺
        </button>
      )}
    </div>
  );
}
